import {
    createSlice,
    createEntityAdapter,
} from '@reduxjs/toolkit';
import { nonTradingEventUpdate } from '~SpectateStore/actions/nonTradingEventUpdate';
import { inplayEventData } from '~SpectateStore/thunks/inplayEventData';
import { eventOver, eventUpdate } from '~SpectateStore/actions/eventUpdate';
import { storeCleanup } from '~SpectateStore/actions/storeCleanupActions';
import { eventInplayStart } from '~SpectateStore/actions/eventInplayStart';
import { eventRescheduled } from '~SpectateStore/actions/eventRescheduled';
import {
    moreGamesUpdate,
} from '~SpectateStore/actions/moreGamesActions';
import {
    dataPointersUpdate,
} from '~SpectateStore/actions/dataPointersActions';

export const SLICE_NAME = 'events';

export const eventsAdapter = createEntityAdapter();

const eventsSlice = createSlice({
    name: SLICE_NAME,
    initialState: eventsAdapter.getInitialState(),
    reducers: {
        updateSelectedMarketGroup: (state, { payload: { eventId, slug }}) => {
            state.entities[eventId]['selected_tab'] = slug;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(
                storeCleanup,
                (state, { payload: { eventIds } }) => {
                    eventsAdapter.removeMany(state, eventIds);
                },
            )
            .addCase(
                inplayEventData.fulfilled,
                (state, { payload : { event } }) => {
                    if (Object.keys(event).length > 0) {
                        return eventsAdapter.upsertOne(state, event);
                    }

                    return state;
                },
            )
            .addCase(
                nonTradingEventUpdate,
                (state, { payload : { event } }) => {
                    return eventsAdapter.upsertOne(state, event);
                },
            )
            .addCase(
                eventOver,
                (state, { payload : { eventId, changes } }) => {
                    eventsAdapter.updateOne(state, {
                        id: eventId,
                        changes,
                    });
                },
            )
            .addCase(
                eventUpdate,
                (state, { payload : { event } }) => {
                    return eventsAdapter.upsertOne(state, event);
                },
            )
            .addCase(
                eventRescheduled,
                (state, { payload : { eventId, rescheduledTime } }) => {
                    eventsAdapter.updateOne(state, {
                        id: eventId,
                        changes: { scheduled_start_time: rescheduledTime },
                    });
                },
            )
            .addCase(
                moreGamesUpdate,
                (state, { payload : { events } }) => {
                    eventsAdapter.upsertMany(state, events);
                },
            )
            .addCase(
                dataPointersUpdate,
                (state, { payload : { events = {} } }) => {
                    if (Object.keys(events).length > 0) {
                        return eventsAdapter.upsertMany(state, events);
                    }

                    return state;
                },
            )
            .addCase(
                eventInplayStart,
                (state, { payload : { events } }) => {
                    return eventsAdapter.upsertMany(state, events);
                }
            );
    },
});

export const { updateSelectedMarketGroup } = eventsSlice.actions;
export default eventsSlice.reducer;
